export default __webpack_public_path__ + "static/media/Group9217.defa2141.svg";